import config from '../config.js';
import resource from "../../model/resource.js";

var backupModel;

//检查文件是否合法
function checkFiles(list, success){		//检查文件是否合法
	let files = list.tempFiles;
	let idx = 0;
	let errFiles = [];
	let setting	=  config.data.setting ? config.data.setting.models : dyEditor.member.model;
	let max = setting - config.data.models.length;
	let type = config.data.models.length >0 ? config.data.models[0].fileType : files[0].name.substr(-3);
	
	for(let i in files)
	{
		let file = files[i];
		let t = file.name.substr(-3);
		let name = file.name;
		
		if( t != type) {
			dyEditor.dialog.show({
				title:'系统提示',
				confirmText:'我知道了',
				cancel:false,
				content:{
					title:'上传的模型文件格式冲突，无法上传！',
					text:'请上传相同格式的模型文件'
				}
			});
			return;
		}
		
		if(files.length>1&&(t=='glb'||t=='ltf'||t=='obj')){
			dyEditor.dialog.show({
				title:'系统提示',
				confirmText:'我知道了',
				cancel:false,
				content:{
					title:'所选择的格式只支持单文件上传',
					text:' .obj / .glb / .gltf 文件只支持单模型文件上传，请重新进行选择'
				}
			});
			return;
		}
		
		uni.getFileInfo({
			filePath: file.path,
			success	: f=>{
				
				// if(res.width / 2 != res.height){
				// 	file.err = true;
				// 	errFiles.push({
				// 		name: file.name,
				// 		text: '不是2:1深度图，无法上传',
				// 	});
				// }
				
				if(t == 'png' && f.size > 30 * 1024 * 1024){
					file.err = true;
					errFiles.push({
						name: name,
						text: '深度图超出30MB的最大限制，无法上传',
					});
				} else if((t == 'obj'|| t == 'glb'|| t == 'ltf') && f.size > 1024 * 1024 * 1024 * 2){
					file.err = true;
					errFiles.push({
						name: name,
						text: '模型超出2GB的最大限制，无法上传',
					});
				} else if((t == 'zip') && f.size > 300 * 1024 * 1024){
					file.err = true;
					errFiles.push({
						name: name,
						text: 'zip超出300M的最大限制，无法上传',
					});
				} else if(t == 'ply' && f.size > 300 * 1024 * 1024){
					file.err = true;
					errFiles.push({
						name: name,
						text: 'ply点云超出300MB的最大限制，无法上传',
					});
				} else if(i>=max){
					file.err = true;
					errFiles.push({
						name: name,
						text: '超出最大数量上限，无法上传',
					});
				}
				
				//检查完成
				if(idx++ >= files.length -1) {
					files = files.filter(item => {
						return !item.err;
					});
		
					if(errFiles.length>0){
						dyEditor.dialog.files({
							title:'系统提示',
							height:'550px',
							files:errFiles,
						});
					}
					
					success && success(files);
				}
			}
		});
	}
}

function upload(files, item, index, success){
	let count = 0;
	let max = files.tempFiles.length;
	
	//检查文件是否合法
	checkFiles(files, list=>{
		resource.uploadFiles(config.id, list, {
			type : 'model',
			ready : res=>{
				config.isUpdate = config.modelUpdate = true;
				if(!item) {
					return dy3d.model.add({id:res.id, name:res.name, size:res.size, fileType:res.extName});
				} else {
					let item	= dy3d.model.get(index);
					item.id		= res.id;
					item.status = 0;
					return item;
				}
			},
			success	: res=>{
				res.item.status			= 1;
				res.item.progress		= 0;
				res.item.update_time	= parseInt(new Date().getTime() / 1000);
				offsetOverlap();
				if(++count >= max) {
					success && success(count, max);
				}
			},
			progress : res=>{
				res.item.progress = res.num;
			},
			error : ()=>{
				dyEditor.toast.error('模型文件上传失败!');
				if(++count >= max) {
					success && success(count, max);
				}
			}
		});
	});
}

function offsetOverlap(){
	let models		= config.data.models;
	let repeated	= false;
	
	const modelMap = new Map(models.map((p,i)=> [p.offset.x+','+p.offset.y+','+p.offset.z, {idx:i, item:p}]));
	
	//GWL 2025.10.24重新实现  通过map查询可以提高100倍的性能
	models.forEach(v=>v.repeated=false);
	models.forEach((v,i)=>{
		const k = modelMap.get(v.offset.x+','+v.offset.y+','+v.offset.z);
		if(k && k.idx>i){
			repeated = v.repeated = k.item.repeated = true;
		}
		
		// for(let j=i+1; j<models.length; j++){
		// 	let k = models[j];
		// 	if(v.offset.x == k.offset.x
		// 	&& v.offset.y == k.offset.y
		// 	&& v.offset.z == k.offset.z) 
		// 		repeated = v.repeated = k.repeated = true;
		// }
	});
	return repeated;
}

function repeatIndex(item,index){
	//数组有findIndex方法可以很方便的获取指定数据的下标
	return config.data.models.findIndex((v,i)=>{
		return i!=index 
			&& v.offset.x == item.offset.x
			&& v.offset.y == item.offset.y
			&& v.offset.z == item.offset.z
	});
}

//GWL 这里的方法应该与pano.js统一名称 另外不要在循环中多次使用下标遍历数组!!
// function getRepeatNum(item,index){
// 	let models = config.data.models;
	
// 	for(let i=0; i<models.length; i++){
// 		if(i!=index 
// 		&& models[i].offset.x == item.offset.x 
// 		&& models[i].offset.y == item.offset.y 
// 		&& models[i].offset.z == item.offset.z){
// 			return i;
// 		}
// 	}
// }

function hasModel () {
	// if(config.data.id != config.data.resourceId) return false;
	
	for(let i=0; i<config.data.models.length; i++){
		if(config.data.models[i].status == 3) return true;
	}
	return false;
}

function hasUpdate(model){
	return model && backupModel &&
		(model.id != backupModel.id
		|| model.lock != backupModel.lock
		|| model.name != backupModel.name
		|| model.size != backupModel.size
		|| model.status != backupModel.status
		|| model.visible != backupModel.visible
		|| model.fileType != backupModel.fileType
		|| model.update_time != backupModel.update_time
		|| model.offset.x != backupModel.offset.x 
		|| model.offset.y != backupModel.offset.y
		|| model.offset.z != backupModel.offset.z
		|| model.rotate.x != backupModel.rotate.x
		|| model.rotate.y != backupModel.rotate.y
		|| model.rotate.z != backupModel.rotate.z);
}

function backup(model){
	backupModel = {
		id			: model.id,
		name		: model.name,
		lock		: model.lock,
		size		: model.size,
		status		: model.status,
		visible		: model.visible,
		selected	: model.selected,
		fileType	: model.fileType,
		update_time	: model.update_time,
		offset		: {
			x : model.offset.x,
			y : model.offset.y,
			z : model.offset.z,
		},
		rotate		: {
			x : model.rotate.x,
			y : model.rotate.y,
			z : model.rotate.z,
		},
		///////////////////////////////////////
		//WebGL使用的属性
		mesh		: model.mesh,
		///////////////////////////////////////
	}
	
	//因为model对象中有webgl相关属性 无法做json序列化
	//JSON.parse(JSON.stringify(model));
}

function restore(item){
	for(let key in backupModel){
		item[key] = backupModel[key];
	}
	return item;
}

function getBackup(){
	return backupModel;
}

function count(){
	return config.data.models ? config.data.models.length : 0;
}

function removePanoId(panoId){
	let models = config.data.models;
	
	for(let i=0; i<models.length; i++){
		const model = models[i];
		if(model.panoId == panoId) delete model.panoId;
	}
}

export default {
	upload,
	offsetOverlap,
	hasModel,
	hasUpdate,
	backup,
	restore,
	repeatIndex,
	getBackup,
	count,
	removePanoId,
}